import { LabelDisplayedRowsArgs } from "@mui/material";
import { useTranslation } from "react-i18next";

export const defaultLabelDisplayedRows = ({
  from,
  to,
  count
}: LabelDisplayedRowsArgs) => {
  const { t } = useTranslation();

  return `${from}–${to} ${t("table.to")} ${count !== -1 ? count : `${t("table.more_than")} ${to}`}`;
};
